import React, { useContext, useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { isMobile } from '../../utils/utils';
import { Context as AuthContext } from '../../Redux/context/AuthContext';
import { IconButton } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import styles from './style.module.scss';

const FaqComponent = ({ showFaq, showClose, faqOpen, closeFaqOpen, toggleNav }) => {
  const { logout } = useContext(AuthContext);
  const [showModal, setShowModal] = useState(showFaq);

  const handleClose = async () => {
    setShowModal(false);
    await logout();
    window.location.reload();
  };

  useEffect(() => {
    if (faqOpen) {
      setShowModal(true);
    }
  }, [faqOpen]);

  const FAQObj = [
    {
      question: 'What is Arzooo Assured?',
      answer:
        'Arzooo Assured is one of its kind payment coverage program for our Gold and Platinum Sellers. Sellers covered with Arzooo Assured will receive flat Rs 1000/- per day in case of any payment breach. This is a bold step in showing our commitment towards building a strong and long lasting relationship with our sellers.',
    },
    {
      question: 'What is the penalty of cancellation/ expiry?',
      answer:
        'No Penalty will be levied if the Cancellations + Expiry + Rejections in a calendar month  is less than 2. However if any seller breaches this number, they will be charged with a penalty of Rs 250/1% of order amount(whichever is higher) for all the breached orders.',
    },
    {
      question: 'What is the payment cycle?',
      answer: `We process the payment within 10 days from the date of pickup of shipment from the seller's location. Please note that payments are processed on every Tuesday and Friday.`,
    },
    {
      question: 'How is the Falcon tier decided? How can I move up?',
      answer:
        'All the sellers are rated on two factors: business they do with Arzooo and the hygiene in fulfillment. The more business you do with Arzooo and the better your hygiene is(no cancellations, expiry and rejections), the better the chances of you being in a higher slab. Falcon tiers will be recomputed every month so based on your performance, you can expect your tier to change at the start of the month.',
    },
  ];

  return (
    <div className={styles.mainContainer}>
      <Modal
        show={showModal}
        onHide={handleClose}
        size="lg"
        centered
        backdrop="static"
        className="h-300"
        style={{
          background: 'rgba(2, 2, 2, 0.7)',
        }}
      >
        <Modal.Header>
          <Modal.Title className={styles.title}>FAQs</Modal.Title>
          <div className="d-flex justify-content-end">
            {showClose && (
              <IconButton
                className={styles.iconBtn}
                onClick={() => {
                  setShowModal(false);
                  closeFaqOpen(false);
                  toggleNav(true);
                }}
              >
                <CancelIcon className={styles.cancelBtn} />
              </IconButton>
            )}
          </div>
        </Modal.Header>
        <Modal.Body className={!isMobile() ? styles.modalBody_Mobile : styles.modalBody}>
          <div className="d-flex justify-content-between align-items-center">
            <div className={isMobile() ? styles.falcon_img_mobile : styles.falcon_img}>
              <img
                alt="arzooo-header-logo"
                src="https://static.arzoopro.com/images/falcon-logo.png"
                max-width="100%"
                height="100%"
              ></img>
            </div>
            <div className={isMobile() ? styles.arzooo_img_mobile : styles.arzooo_img}>
              <img
                alt="arzooo-header-logo"
                className="headerLogo"
                src="https://static.arzoopro.com/images/f+logo-01.png"
                max-width="100%"
                height="100%"
              ></img>
            </div>
          </div>

          <div className={styles.content}>
            {FAQObj.map((item, index) => {
              return (
                <ul start="1" key="question_index">
                  <li dir="ltr" className={styles.listType}>
                    <p dir="ltr">
                      <strong>Q: {item.question} </strong>
                      <div className={styles.answer}>
                        <strong>A: </strong>
                        <span>{item.answer}</span>
                      </div>
                    </p>
                  </li>
                </ul>
              );
            })}
          </div>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </div>
  );
};

export default FaqComponent;
